import { create } from 'zustand';
import type { MissedRing } from '@etown/shared';

interface MissedRingsState {
  /** Offene Hinweise, juengster zuerst. */
  entries: MissedRing[];
  setAll: (entries: MissedRing[]) => void;
  /** Neuer Hinweis vom Server; ein vorhandener desselben Anrufers wird ersetzt. */
  addOrReplace: (entry: MissedRing) => void;
  /** Quittiert: der Hinweis verschwindet, Karte und Zaehler zugleich. */
  dismiss: (fromUserId: string) => void;
  reset: () => void;
}

/**
 * Verpasste Anklingelversuche.
 *
 * Die Wahrheit liegt in der Datenbank — dieser Speicher ist nur die Sicht
 * darauf. Deshalb kein eigenes Zusammenzaehlen: der Server liefert je
 * Anrufer bereits Anzahl und juengsten Zeitpunkt.
 */
export const useMissedRingsStore = create<MissedRingsState>((set) => ({
  entries: [],

  setAll: (entries) => set({ entries }),

  addOrReplace: (entry) =>
    set((state) => ({
      entries: [entry, ...state.entries.filter((e) => e.fromUserId !== entry.fromUserId)],
    })),

  dismiss: (fromUserId) => set((state) => ({ entries: state.entries.filter((e) => e.fromUserId !== fromUserId) })),

  reset: () => set({ entries: [] }),
}));

/** Wie viele Personen vergeblich angeklingelt haben (FAB-Badge). */
export function selectMissedRingCount(state: MissedRingsState): number {
  return state.entries.length;
}
